import { buildApiUrl, Type, sendPostRequest, ErrorResponse } from '@/api/api'

export interface ApproveResponse {
  Data: {
    Approved: number
    Rejected: string[]
  }
  Errors: string[] | null
}

export async function approveTariffs(groupKeys: string[], userId: string | undefined) {
  if (!userId) throw new Error('User ID is required to approve tariffs.')
  const url = buildApiUrl(Type.TariffManagement, `approve-tariffs?userId=${encodeURIComponent(userId)}`)

  try {
    const { data } = await sendPostRequest<ApproveResponse>(url, groupKeys)
    return data
  } catch (error) {
    if (error instanceof ErrorResponse) {
      throw { data: error.body as ApproveResponse | null, response: error.response }
    }
    throw error
  }
}
